var map = {
	"./12_cr.jpg": 195,
	"./56.jpg": 196,
	"./arn.jpg": 197,
	"./bottle_crates.jpg": 198,
	"./h310.jpg": 199,
	"./isr.jpg": 200,
	"./kof.jpg": 201,
	"./kofa2_cr.jpg": 202,
	"./kofab5.jpg": 203,
	"./kofab7.jpg": 204,
	"./kola.jpg": 205,
	"./ldc.jpg": 206,
	"./lnpk.jpg": 207,
	"./meso.jpg": 208,
	"./paletprod.jpg": 209,
	"./ung.jpg": 210
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds nonrecursive \.(png|jpe?g|svg)$
// module id = 194
// module chunks = 0